import { IUserAttributes, IUserType } from "./IUser";

export enum CommentType {
  COLD_CORRESPONDENCE = "ColdCorrespondence",
  COMMENT = "Comment",
  EMAIL_CORRESPONDENCE = "EmailCorrespondence",
  INPERSON_CORRESPONDENCE = "InpersonCorrespondence",
  PHONE_CORRESPONDENCE = "PhoneCorrespondence",
  SOCIAL_CORRESPONDENCE = "SocialCorrespondence",
}

export interface ICommentPayload {
  text: string;
  custom_type?: string | null;
  type: string | null;
  locationOn?: boolean;
  latitude?: number | null;
  longitude?: number | null;
}

export interface ICommentAttributes {
  address: string;
  createdAt: string;
  customType: string | null;
  id: number;
  latitude: number | null;
  longitude: number | null;
  leadId: number;
  leadIdentifier: string;
  photoUrls: string[];
  recordingUrl: string | null;
  textMentionSafe: {
    text: string;
    userMap: {
      [key: string]: {
        fullName: string;
        tag: string;
        profileImageUrl: string;
        type: IUserType;
      };
    };
  };
  text: string;
  type: CommentType | null;
  updatedAt: string;
  user: IUserAttributes;
  userId: number;
}

export interface IComment {
  attributes: ICommentAttributes;
  id: string;
  type: string;
}
